const routesMatcher = paths => {
	const routesRE = new RegExp(`^(${paths.join('|')})(/.*)*.*$`, 'i');
	return value => routesRE.test(typeof value === 'object' ? value.pathname : value);
};

export default routesMatcher;
